export default __webpack_public_path__ + "static/media/610.59287f3b.png";